const genericQuestions = [
  {
    question: 'What\'s the xx you are looking for?',
    labels: [
      'Plank Width',
      'Approximate Plank Size (in.)',
      'Category',
      'Plank Width',
      'Species',
      'Review Rating',
      'Approximate Thickness (in.)',
      'Veneer Wear Layer Thickness (mm)',
      'Approximate Tile Size',
      'Finish Type',
      'Trim Profile',
      'Trim Type',
      'Flooring and Tile Look',
      'Shade',
    ],
  },
  {
    question: 'What xx do you need?',
    labels: [
      'Wear Layer Thickness (mil)',
      'Features',
      'Water Protection',
      'Laminate Flooring Features',
      'Species',
      'Tile Finish',
      'Wood Species',
      'Hardwood Floor Features',
      'Molding/Trim Type',
      'AC Rating',
      'Stair Tread Type',
    ],
  },
  { question: 'What Color do you need?', labels: ['Color Family'] },
  { question: 'Where is your Flooring going?', labels: ['Location'] },
  { question: 'Where is the Application Location?', labels: ['Application Location'] },
  { question: 'What price range are you looking for?', labels: ['Price'] },
];

export const buildQuestion = (label) => {
  const genericQuestion = genericQuestions.find((genQuestion) => {
    return genQuestion.labels.includes(label) ? genQuestion.question : null;
  });
  return genericQuestion?.question.toString().replace('xx', label);
};

export const buildURLRedirect = (selectedAnswers) => {
  const singleAnswerPresent = selectedAnswers.filter((answer) => answer !== null).length === 1;
  let refinementKeys = '5yc1v';

  if (singleAnswerPresent) {
    return `/b/N-${selectedAnswers[0]?.refinementKey}`;
  }

  selectedAnswers.forEach((answerObj, index) => {
    if (index === 0 || !answerObj) return;
    if (answerObj?.refinementKey) {
      refinementKeys += `Z${answerObj.refinementKey}`;
    } else if (Array.isArray(answerObj)) {
      answerObj.forEach((obj) => {
        refinementKeys += `Z${obj.refinementKey}`;
      });
    }
  });

  return `/b/N-${refinementKeys}`;
};

export const buildNavParam = (selectedAnswers, questionIndex, resultsPageNav) => {
  let navParam = '5yc1v';
  const filteredAnswers = resultsPageNav
    ? selectedAnswers
    : selectedAnswers.slice(0, questionIndex);
  const singleAnswerPresent = filteredAnswers.filter((answer) => answer !== null).length === 1;

  if (singleAnswerPresent) {
    return selectedAnswers[0]?.refinementKey;
  }

  filteredAnswers.forEach((answerObj, index) => {
    if (index === 0 || !answerObj) return;
    if (answerObj?.refinementKey) {
      navParam += `Z${answerObj.refinementKey}`;
    } else if (Array.isArray(answerObj)) {
      answerObj.forEach((obj) => {
        navParam += `Z${obj.refinementKey}`;
      });
    }
  });

  return navParam;
};

const parseLabelArray = (input) => {
  if (typeof input === 'string') {
    try {
      return JSON.parse(input.replace(/'/g, '"'));
    } catch {
      return [];
    }
  }
  return Array.isArray(input) ? input : [];
};

export const isFlooringPLPUtil = ({ itemId, taxonomy, flooringLabels, excludedFlooringLabels }) => {
  if (itemId || !taxonomy?.breadCrumbs?.length) return false;

  const parsedLabels = parseLabelArray(flooringLabels).map((label) => label.toLowerCase());
  const parsedExcludedLabels = parseLabelArray(excludedFlooringLabels).map((label) => label.toLowerCase()
  );
  const breadCrumbLabels = taxonomy.breadCrumbs
    .filter((breadCrumb) => {
      const hasLabel = typeof breadCrumb?.label === 'string';
      const hasBrowseUrlField = Object.hasOwn(breadCrumb ?? {}, 'browseUrl');
      return hasLabel && (!hasBrowseUrlField || Boolean(breadCrumb?.browseUrl));
    })
    .map(({ label }) => label.toLowerCase());
  // eslint-disable-next-line max-len
  const hasExcluded = breadCrumbLabels.some((crumbLabel) => parsedExcludedLabels.some((excluded) => crumbLabel.includes(excluded))
  );
  if (hasExcluded) return false;
  return parsedLabels.some((label) => breadCrumbLabels.includes(label));
};

export const parseUrl = ({ path }) => {
  const parts = path.replace(/^\/render[^/]*/, '').split('?');
  const leftOfQuery = parts[0] || '';
  let queryString = parts[1] || '';

  let [_, context, category, ...pieces] = leftOfQuery.split('/');

  const slugs = [];
  let keyword;
  let nValue;

  if (
    queryString
    && queryString.indexOf('lowerBound') > -1
    && queryString.indexOf('upperBound') > -1
  ) {
    queryString = queryString.replace('lowerBound', 'lowerbound');
    queryString = queryString.replace('upperBound', 'upperbound');
  }

  if (context === 's') {
    keyword = category;
    category = 'search';
  }
  if (/^N-/.test(category)) {
    nValue = category;
    category = null;
  }
  (pieces || []).forEach((piece) => {
    if (!/^Ntt-|^Ntk-|N-5/.test(piece)) {
      slugs.push(piece);
    } else if (/^Ntt-/.test(piece)) {
      keyword = piece
        .substring(4, piece.length)
        ?.split(/\+|%2B/)
        .join(' ');
    } else if (/^N-/.test(piece)) {
      nValue = piece.substring(2, piece.length);
    }
  });

  const params = (queryString.match(/(\w+)=([^&]+)/g) || [])
    .map((val) => {
      const param = val.split('=');
      return {
        [param[0]]: param[1],
      };
    })
    .reduce((acc, next) => {
      const key = Object.keys(next)[0];
      return {
        ...acc,
        [key]: next[key],
      };
    }, {});

  if (params.storeIds) {
    params.storeIds = params.storeIds.split(',');
  }

  if (keyword) {
    if (keyword.match(/^https?:/)) {
      keyword = '';
    }
  }

  return {
    slugs,
    keyword,
    context,
    category,
    nValue,
    ...params,
  };
};
